<template>
  <Modal
    v-model="_value"
    width="500"
    title="JT808设置所有设备会汇报间隔"
    @on-visible-change="visibleChange"
    ok-text="发送"
    @on-ok="onOk">
    <Form :model="reqParams" :label-width="80">
      <FormItem prop="accOn" label="ACC开上传间隔">
        <InputNumber :min="0" v-model="reqParams.accOn" placeholder="请输入ACC开上传间隔">
        </InputNumber>
      </FormItem>
      <FormItem prop="accOff" label="ACC关上传间隔">
        <InputNumber :min="0" v-model="reqParams.accOff" placeholder="请输入ACC关上传间隔">
        </InputNumber>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'jt808setallreportintervalmodal',
    props: {
      value: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        reqParams: {
          accOn:0,
          accOff:0
        }
      }
    },
    methods: {
      ...mapActions([
        'Jt808DeviceServ_ResetAllReportInterval'
      ]),
      onOk() {
        this.$Modal.confirm({
          title: '提示',
          content: '<p>注意：所有设备将设置成统一汇报间隔</p>',
          onOk: () => {
            store.dispatch('Jt808DeviceServ_ResetAllReportInterval', {
              params: this.reqParams
            }).then(() => {
              this.$Message.success('发送成功')
            }).catch(err => {
              this.$Message.error(err)
            })
          },
          onCancel: () => {
          }
        })
      },
      visibleChange(val) {
        if(val){
          this.reqParams.accOn = 0
          this.reqParams.accOff = 0
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
